import {API_URLS} from '@px/const/urls';
import {http} from '@px/helper/http';

export const investmentApi = {
  getProduct() {
    return http.get(API_URLS.INVESTMENT_PRODUCT, {});
  },
};
